<template>
  <div>
    <template>
      <b-modal v-model="modalOk" :active="modalOk" :width="900" :height="2000" :on-cancel="() => {
        modalOk = false
      }
        ">
        <div class="card">
          <div class="card-content">
            <header class="modal-card-head">
              <p class="modal-card-title">{{ title }}</p>
              <button class="delete" type="button" @click="closing()"></button>
            </header>
            <template>
              <div>
                <section class="container section page-header section is-main-section">
                  <form @submit.prevent="saveSettings">
                    <div>
                      <card-component>
                        <label class="label" v-if="type === 'gst-setting'">The FeeType amount is inclusive of Tax </label>
                        <div class="field" v-if="type === 'gst-setting'">
                          <b-switch v-model="GSTtax.isFeetypeInclusiveTax">
                            {{ GSTtax.isFeetypeInclusiveTax ? GSTtax.isFeetypeInclusiveTax : false }}
                          </b-switch>
                        </div>
                        <div class="columns">
                          <div class="column " v-if="type === 'gst-setting'">
                            <div class="field">
                              <label class="label">
                                TAX Head Name
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control select is-fullwidth">
                                <select required v-model="GSTtax.taxHeadName">
                                  <option value="">-----Select-----</option>
                                  <option value="VAT">VAT</option>
                                  <option value="GST">GST</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="column" v-if="type === 'gst-setting'">
                            <div class="field">
                              <label class="label">
                                HSN Code
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control  is-fullwidth">
                                <input required class="input" placeholder="HSN Code" @keyup="exceptEValidation" step="any"
                                  type="number" v-model.trim="GSTtax.hsnCode" />
                              </div>
                            </div>
                          </div>
                          <div class="column " v-if="type === 'aesc-setting'">
                            <div class="field">
                              <label class="label">
                                Share of Corp.office AESC
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control  is-fullwidth">
                                <input required class="input" placeholder="Share of Corp.office AESC"
                                  @keyup="exceptEValidation" step="any" type="number" v-model="AESC.corporateTax" />
                              </div>
                            </div>
                          </div>
                          <div class="column " v-if="type === 'aesc-setting'">
                            <div class="field">
                              <label class="label">
                                Service Tax
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control  is-fullwidth">
                                <input required class="input" @keyup="exceptEValidation" step="any"
                                  placeholder="Service Tax" type="number" v-model.trim="AESC.serviceTax" />
                              </div>
                            </div>
                          </div>
                          <div class="column " v-if="type === 'aesc-setting'">
                            <div class="field">
                              <label class="label">
                                TDS Tax
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control  is-fullwidth">
                                <input required class="input" @keyup="exceptEValidation" step="any" placeholder="TDS"
                                  type="number" v-model.trim="AESC.tdsTax" />
                              </div>
                            </div>
                          </div>
                          <div class="column" v-if="type === 'gst-setting'">
                            <div class="field">
                              <label class="label">
                                Tax Percentage:
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control  is-fullwidth">
                                <input required class="input" @keyup="percentageValidation" placeholder=" Tax%"
                                  type="number" v-model.trim="GSTtax.gstTax" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label class="label">Select Year <span class="has-text-danger">*</span></label>
                              <div class="control">
                                <span class="select is-fullwidth">
                                  <select v-model="academicYearID" required @change="changeYear(currentYear)">/
                                    <option value>--Select--</option>
                                    <option v-for="info in currentYear" :key="info.id" :value="info.id"> {{
                                      info.academicYear }}</option>
                                  </select>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="column" v-if="type === 'gst-setting'">
                            <div class="field">
                              <label class="label">
                                Percentage of feeType Amount to be considered for Tax
                              </label>
                              <div class="control  is-fullwidth">
                                <input required class="input" placeholder="Minimum FeeType Tax"
                                  @keyup="percentageValidation" type="number" v-model.trim="GSTtax.minimumFeeTypeTax" />
                              </div>
                            </div>
                          </div>
                          <div class="column" v-if="type === 'aesc-setting'">
                            <label class="label">
                              Effective Start Date
                              <span class="has-text-danger">*</span>
                            </label>
                            <input class="input" v-model="AESC.effectiveDate" :min="minDate" :max="maxDate" type="date"
                              required />
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label class="label">Type of Fee <span class="has-text-danger">*</span></label>
                              <div class="control">
                                <span class="select is-fullwidth">
                                  <select v-model="moduleID" required @change="feeTypeName(moduleID)">/
                                    <option value>--Select--</option>
                                    <option v-for="info in feeModuleType" :key="info.id" :value="info.id"> {{ info.name }}
                                    </option>
                                  </select>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="column ">
                            <div class="field">
                              <label class="label">
                                Select Franchisee

                                <span class="has-text-danger">*</span>
                                <span> <b-checkbox v-model="flag" @input="allFranchisee"> All</b-checkbox></span>
                              </label>

                              <div class="control select is-fullwidth">
                                <multiselect class="overflowmultiselect1" label="companyName" track-by="companyName"
                                  :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                                  :preselect-first="false" :multiple="true" :options="franchiseeArr" :optionHeight="10"
                                  v-model="franchisee" @remove="onTouch">
                                  <template slot="selection" slot-scope="{ values, isOpen }"><span
                                      class="multiselect__single" v-if="values.role &amp;&amp; !isOpen">{{
                                        values.companyName }} </span></template>
                                </multiselect>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <div class="field" v-if="isAdmission">
                              <label class="label">Fee Type <span class="has-text-danger">*</span></label>
                              <div class="control select is-fullwidth">
                                <multiselect class="overflowmultiselect1" label="name" track-by="name"
                                  :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                                  :preselect-first="false" :multiple="true" :options="feeType" :optionHeight="10"
                                  v-model="feeTypeID" @remove="onTouch">
                                  <template slot="selection" slot-scope="{ values, isOpen }"><span
                                      class="multiselect__single" v-if="values.role &amp;&amp; !isOpen">{{ values.name
                                      }} </span></template>
                                </multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="column"></div>
                        </div>
                        <footer class="column has-text-left" style="margin-top: 70px;">
                          <button class="button is-success" type="submit">Save</button>
                        </footer>
                      </card-component>
                    </div>
                  </form>
                </section>
              </div>
            </template>
          </div>
        </div>
      </b-modal>
    </template>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">{{ title }}</p>
          </div>
        </div>
        <div class="level-right p-t-10">
          <div class="level-item">
            <router-link :to="{ name: 'settingView' }" class="button is-small is-link">Back to Settings</router-link>
          </div>
          <div class="level-item">
            <button class="button is-info is-small btnicon" @click="ModalOpen()" title="Add">
              Create Settings
            </button>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column ">
          <drop-down type="forAcadmicYear" @change="onStart"></drop-down>
        </div>
        <div class="column is-6">
          <drop-down type="forFranchiseeSelection" @change="onStart"></drop-down>
        </div>
      </div>
      Total Records :
      <b>{{ total }}</b>
    </section>
    <section v-if="type === 'gst-setting'" class="section is-main-section">
      <card-component title class="has-table has-mobile-sort-spaced">
        <b-table paginated :per-page="perPage" :striped="true" :hoverable="true" :data="concessionInfo"
          style="overflow-x:scroll">
          <template slot-scope="props">
            <b-table-column field="index" label="S.No" sortable> {{ props.index + 1 }} </b-table-column>
            <b-table-column field="franchisee.companyName" label="Franchisee Name " sortable>
              <b-tag type="is-info">{{ props.row.franchisee.companyName }} </b-tag>
            </b-table-column>
            <b-table-column field="feeType.name" label="Fee Type" sortable>
              <b-tag type="is-dark">{{ props.row.feeType ? props.row.feeType.name : 'N/A' }}</b-tag>
            </b-table-column>

            <b-table-column field="feeType.name " label="Tax Head Name" sortable>
              <b-tag type="is-info">{{ props.row.taxHeadName }} </b-tag></b-table-column>
            <b-table-column field="hsnCode" label="HSN Code" sortable>
              <b-tag type="is-info">{{ props.row.hsnCode }} </b-tag></b-table-column>

            <b-table-column field="gstTax" label="Tax %" sortable> {{ props.row.gstTax }}</b-table-column>

            <b-table-column field="minimumFeeTypeTax" label="Minimum Fee Type Tax" sortable> {{
              props.row.minimumFeeTypeTax || 0 }}</b-table-column>
            <b-table-column field="effectiveStartDate" label="Effective Start Date" sortable> {{ new
              Date(effectiveStartDate).toLocaleDateString() }}</b-table-column>
            <b-table-column field="effectiveEndDate" label="Effective End Date" sortable> {{ new
              Date(effectiveEndDate).toLocaleDateString() }}</b-table-column>

            <b-table-column :class="isActiveColor[props.row.isActive]" field="isActive" label="Status" sortable> {{
              props.row.isActive ? 'Active' : 'Not Active' }}</b-table-column>

            <b-table-column label="Action" custom-key="actions" class="is-actions-cell" width="140" centered>
              <div class="buttons">
                <button class="button is-small is-danger" type="button" @click.prevent="deactivateSetting(props.row.id)"
                  v-if="props.row.isActive" title="Deactivate">
                  <b-icon icon="trash-can" size="is-small" />
                </button>
                <button class="button is-small is-success" type="button" @click.prevent="restoreSetting(props.row.id)"
                  v-if="!props.row.isActive" title="Restore">
                  <b-icon icon="restore" size="is-small" />
                </button>
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>Nothing here.</p>
              </div>
            </section>
          </template>
        </b-table>
      </card-component>
    </section>

    <section v-if="type === 'aesc-setting'" class="section is-main-section">
      <card-component title class="has-table has-mobile-sort-spaced">
        <b-table paginated :per-page="perPage" :striped="true" :hoverable="true" :data="concessionInfo"
          style="overflow-x:scroll">
          <template slot-scope="props">
            <b-table-column field="index" label="S.No" sortable> {{ props.index + 1 }} </b-table-column>
            <b-table-column field="franchisee.companyName" label="Franchisee Name " sortable>
              <b-tag type="is-info">{{ props.row.franchisee.companyName }} </b-tag>
            </b-table-column>
            <b-table-column field="feeType.name" label="Fee Type" sortable>
              <b-tag type="is-dark">{{ props.row.feeType ? props.row.feeType.name : '-' }}</b-tag>
            </b-table-column>
            <b-table-column label="Academic Year">
              <b-tag type="is-dark">{{ props.row.franchiseeAcademicYear ? props.row.franchiseeAcademicYear.academicYear :
                '-' }}</b-tag>
            </b-table-column>
            <b-table-column field="corporateTax " label="Share of Corp.Office AESC" sortable>
              <b-tag type="is-info">{{ props.row.corporateTax }} </b-tag></b-table-column>
            <b-table-column field="serviceTax" label="Service Tax" sortable>
              <b-tag type="is-info">{{ props.row.serviceTax }} </b-tag></b-table-column>

            <b-table-column field="tdsTax" label="TDS" sortable> {{ props.row.tdsTax }}</b-table-column>

            <b-table-column field="isTAN" label="Do You have TAN" sortable> {{ props.row.isTAN ? 'Yes' : 'No'
            }}</b-table-column>
            <b-table-column field="effectiveDate" label="Effective Start Date" sortable> {{ new
              Date(props.row.effectiveDate).toLocaleDateString() }}</b-table-column>

            <b-table-column :class="isActiveColor[props.row.isActive]" field="isActive" label="Status" sortable> {{
              props.row.isActive ? 'Active' : 'Not Active' }}</b-table-column>

            <b-table-column label="Action" custom-key="actions" class="is-actions-cell" width="140" centered>
              <div class="buttons">
                <button class="button is-small is-danger" type="button"
                  @click.prevent="deactivateSetting(props.row.id, props.row)" v-if="props.row.isActive"
                  title="Deactivate">
                  <b-icon icon="trash-can" size="is-small" />
                </button>
                <button class="button is-small is-success" type="button"
                  @click.prevent="restoreSetting(props.row.id, props, row)" v-if="!props.row.isActive" title="Restore">
                  <b-icon icon="restore" size="is-small" />
                </button>
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>Nothing here.</p>
              </div>
            </section>
          </template>
        </b-table>
      </card-component>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import Multiselect from 'vue-multiselect'
import constants from '@/utils/constants'
import server from '../../../store/server'
import dialogError from '@/components/dialogError.vue'
import store from '@/store'
import DropDown from '../../reusableComp/dropDown'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'Setting',
  props: ['type'],
  components: { CardComponent, DropDown, Multiselect },
  data () {
    return {
      total: 0,
      paginated: false,
      perPage: 10,
      loadingComponent: null,
      enableFilterModal: false,
      viewMoreData: [],
      modalOk: false,
      title: '',
      fromApiData: [],
      concessionInfo: [],
      isAdmission: false,
      effectiveStartDate: null,
      effectiveEndDate: null,
      isActiveColor: {
        true: 'has-text-success',
        false: 'has-text-danger'
      },
      flag: '',
      franchisee: [],
      GSTtax: {
        taxHeadName: '',

        hsnCode: '',
        gstTax: '',
        feeTypeID: [],
        settingType: '',
        isFeetypeInclusiveTax: false,
        minimumFeeTypeTax: ''
      },
      AESC: {
        effectiveDate: null,

        tdsTax: '',
        corporateTax: '',
        isTAN: false,
        tanNumber: '',
        serviceTax: ''
      },
      feeType: [],
      franchiseeArr: [],
      appendToBody: true,
      maxDate: null,
      minDate: null,
      initialYear: '',
      currentYear: null,
      feeModuleType: [],
      moduleID: '',
      feeTypeID: []
    }
  },

  async created () {
    this.$store.dispatch('getCurrentAcadmicYearID')
    await this.onStart()

    if (this.type === 'gst-setting') {
      this.title = 'GST Settings'
    } else {
      this.title = 'Facilitation Fee Setting'
    }
  },
  computed: {
    academicYearID: {
      get () {
        return store.state.feeComponent.academicYearID
      },
      set (value) {
        store.commit('updateAcadmicYrId', value)
      }
    },
    franchiseeID: {
      get () {
        return store.state.feeComponent.franchiseeID
      },
      set (value) {
        store.commit('updateFranchiseeID', value)
      }
    }
  },

  watch: {
    franchiseeID: function (values) {
      if (!values) {
        this.total = 0
        this.concessionInfo = []
      }
    },
    academicYearID: async function (values) {
      if (!values) {
        this.total = 0
        this.concessionInfo = []
      }
    }
  },
  methods: {
    feeTypeName: function (val) {
      if (val === 1 || val === '') {
        this.GSTtax.feeTypeID = []
        this.feeTypeID = []
        this.isAdmission = false
      } else {
        const feeType = _.find(this.feeModuleType, item => item.id === this.moduleID)
        this.isAdmission = feeType && feeType.name === 'Admission Form'
      }
    },
    changeYear: function (years) {
      console.log('years,academicYearID', this.academicYearID, years)
      if (this.academicYearID) {
        let year = _.map(years, item => {
          if (item.id === this.academicYearID) {
            return item.academicYear
          }
        })

        this.initialYear = _.compact(year)[0].split('-')[0]

        const nextYear = Number(this.initialYear) + 1
        this.minDate = moment(`01/01/${this.initialYear}`).format('YYYY-MM-DD')
        this.maxDate = moment(`03/31/${nextYear}`).format('YYYY-MM-DD')
        this.AESC.effectiveDate = moment(`01/01/${this.initialYear}`).format('YYYY-MM-DD')
      }
    },
    closing: async function () {
      this.modalOk = false
      await this.onStart()
    },
    onTouch: function () {
      this.flag = false
      return true
    },
    allFranchisee: function () {
      let tempArray = []
      if (this.flag === true) {
        this.franchiseeArr.forEach(Obj => {
          tempArray.push(Obj)
        })
      }

      this.franchisee = tempArray
    },

    exceptEValidation: function (event) {
      if (event.target.value === '') {
        event.target.value = ''
        return event
      }
    },
    percentageValidation: function (event) {
      let reg = new RegExp(/(^100([.]0{1,2})?)$|(^\d{1,2}([.]\d{1,2})?)$/)

      let result = event.target.value.match(reg)

      if (!result || result[0] === '') {
        event.target.value = ''
        return event
      }
    },

    onStart: async function () {
      if (this.franchiseeID === '' || this.academicYearID === '') {
        return this.$buefy.toast.open({
          message: 'Please select below details',
          type: 'is-danger',
          duration: 4000
        })
      } else {
        if (this.academicYearID || this.franchiseeID) {
          let payload = {}
          if (this.academicYearID) {
            payload.academicYearID = this.academicYearID
          }
          if (this.franchiseeID) {
            payload.franchiseeID = this.franchiseeID
          }
          let result = await server.get('fee-setting', this, payload)

          if (_.isEqual(result.success, 200)) {
            if (this.type === 'gst-setting') {
              this.fromApiData = _.filter(result.data.feeSettings, item => {
                if (item.settingType === 'GST') {
                  return item
                }
              })
              this.settingType = 'GST'
            } else {
              this.fromApiData = _.filter(result.data.feeSettings, item => {
                console.log('item--', item)
                if (item.settingType === 'AESC') {
                  return item
                }
              })
              this.settingType = 'AESC'
            }
          } else {
            return dialogError.ErrorMsg(result.message, 'is-danger', this)
          }
          this.effectiveStartDate = result.data.academicYearValid.effectiveStartDate
          this.effectiveEndDate = result.data.academicYearValid.effectiveEndDate
          this.concessionInfo = this.fromApiData

          if (!this.concessionInfo) {
            this.total = 0
          } else {
            this.total = this.concessionInfo.length
          }
        }
      }
    },
    getModuleList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/get/fee-module`)
        this.feeModuleType = response.data.rows || response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    getCurrentYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.loadingComponent.close()
        this.currentYear = response.data.rows || response.data || []
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getFranchiseeList: async function (id) {
      this.loadingComponent = this.$buefy.loading.open()
      const data = await server.get('franchisee/active', this)
      this.loadingComponent.close()
      if (_.isEqual(data.success, 200)) {
        this.franchiseeArr = data.data.rows
      } else {
        this.loadingComponent.close()
        return dialogError.ErrorMsg(data.message, 'is-danger', this)
      }
    },

    async ModalOpen () {
      this.modalOk = true
      let that = this

      window.addEventListener('keydown', async function (event) {
        if (event.key === 'Escape' && that.modalOk === true) {
          that.modalOk = false
          await that.onStart()
          console.log('escaped Trigeered')
        }
      })

      this.moduleID = ''
      this.GSTtax = {}
      this.GSTtax.feeTypeID = []
      this.feeTypeID = []

      this.GSTtax.taxHeadName = ''
      this.flag = false

      this.AESC = {}

      this.AESC.effectiveDate = null

      this.franchisee = []

      if (this.type === 'gst-setting') {
        this.title = 'GST Settings'
      } else {
        this.title = 'Facilitation Fee Settings'
      }
      await this.getFranchiseeList()
      await this.getAllList()
      await this.getCurrentYear()
      await this.changeYear(this.currentYear)
      await this.getModuleList()
    },

    getAllList: async function () {
      const data = await server.get('fee-type', this)

      if (_.isEqual(data.success, 200)) {
        this.feeType = data.data.rows
      } else {
        return dialogError.ErrorMsg(data.message, 'is-danger', this)
      }
    },
    saveSettings: async function () {
      if (this.moduleID === 2 && this.feeTypeID === []) {
        return dialogError.ErrorMsg('Fee type should not be blank ', 'is-danger', this)
      }
      if (_.isEmpty(this.franchisee)) {
        return dialogError.ErrorMsg('Select Franchisee ', 'is-danger', this)
      }

      const formdata = {
        franchisee: _.map(this.franchisee, 'id'),
        // feeTypeID: _.map(this.GSTtax.feeTypeID, 'id'),
        feeTypeID: _.map(this.feeTypeID, 'id'),
        moduleID: this.moduleID,

        academicYearID: this.academicYearID
      }
      if (this.GSTtax.hsnCode) {
        formdata.taxHeadName = this.GSTtax.taxHeadName
        formdata.settingType = 'GST'
        formdata.hsnCode = this.GSTtax.hsnCode
        formdata.gstTax = this.GSTtax.gstTax
        formdata.isFeetypeInclusiveTax = this.GSTtax.isFeetypeInclusiveTax
        formdata.minimumFeeTypeTax = this.GSTtax.minimumFeeTypeTax
      } else {
        formdata.settingType = 'AESC'
        formdata.effectiveDate = this.AESC.effectiveDate
        formdata.serviceTax = this.AESC.serviceTax
        formdata.tdsTax = this.AESC.tdsTax
        formdata.corporateTax = this.AESC.corporateTax
        formdata.isTAN = this.AESC.isTAN
      }
      if (this.AESC.tanNumber) {
        formdata.tanNumber = this.AESC.tanNumber
      }
      this.loadingComponent = this.$buefy.loading.open()
      let updateRes = await server.post('fee-setting', this, formdata)
      this.loadingComponent.close()
      if (_.isEqual(updateRes.success, 200)) {
        await this.onStart()
        this.flag = false
        this.GSTtax = {}
        this.AESC = {}
        this.academicYearID = this.academicYearID
        this.modalOk = false
        return dialogError.ErrorMsg('Saved Successfully', 'is-info', this)
      } else {
        this.loadingComponent.close()
        return dialogError.ErrorMsg(updateRes.message, 'is-danger', this)
      }
    },
    deactivateSetting: function (Id) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to deactivate Setting?',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()
            /* deactive  */
            await http.patch(`${constants.API_URL}/api/fee-setting/${Id}`, {
              isActive: false
            })
            that.onStart()
            this.loadingComponent.close()

            return this.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Setting deactivated successfully!',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage = (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in deactivating Setting : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    },
    restoreSetting: function (Id) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to restore Setting?',
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()

            /* restore  */
            await http.patch(`${constants.API_URL}/api/fee-setting/${Id}`, {
              isActive: true
            })
            that.onStart()
            this.loadingComponent.close()

            return that.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Setting restored successfully!',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage = (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in restoring  : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.is-large.modal-close,
.is-large.delete {
  visibility: hidden;
}

.buttons {
  flex-wrap: nowrap;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
